(() => {
  const cleanups = new WeakMap();

  const initialize = (root = document) => {
    const sections = root.matches?.('[data-l-series-comparison]') ? [root] : [...(root.querySelectorAll?.('[data-l-series-comparison]') || [])];
    sections.forEach((section) => {
      if (cleanups.has(section)) return;
      const buttons = [...section.querySelectorAll('[data-l-series-comparison-model]')];
      const columns = [...section.querySelectorAll('[data-l-series-comparison-column]')];
      const modelSelect = section.querySelector('[data-l-series-comparison-select]');
      const mobile = section.querySelector('[data-l-series-comparison-mobile]');
      const dataNode = section.querySelector('[data-l-series-comparison-data]');
      const data = dataNode ? JSON.parse(dataNode.textContent) : {};
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let animation;

      const markup = (model) => {
        const details = data[model];
        if (!details) return '';
        const items = details.included.map((component) => `<li><svg viewBox="0 0 16 16" aria-hidden="true"><path d="m3.25 8.15 2.85 2.8 6.65-6.4"/></svg><span>${component}</span></li>`).join('');
        return `<div class="aqua-l-series-comparison__mobile-header"><strong>${details.positioning}</strong></div><p class="aqua-l-series-comparison__mobile-summary">${details.summary}</p><h3>Included equipment</h3><ul class="aqua-l-series-comparison__mobile-list">${items}</ul>`;
      };
      const select = (model, animate = true) => {
        section.dataset.selectedModel = model;
        if (modelSelect) modelSelect.value = model;
        buttons.forEach((button) => {
          const active = button.dataset.lSeriesComparisonModel === model;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        columns.forEach((column) => column.classList.toggle('is-highlighted', column.dataset.lSeriesComparisonColumn === model));
        if (!mobile) return;
        animation?.cancel();
        mobile.innerHTML = markup(model);
        if (!animate || reducedMotion.matches || typeof mobile.animate !== 'function') return;
        const nextAnimation = mobile.animate([{ opacity: .72, transform: 'translateY(3px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 220, easing: 'ease-out' });
        animation = nextAnimation;
        nextAnimation.finished.catch(() => {}).finally(() => { if (animation === nextAnimation) animation = undefined; });
      };
      const handlers = buttons.map((button) => {
        const handler = () => select(button.dataset.lSeriesComparisonModel);
        button.addEventListener('click', handler);
        return () => button.removeEventListener('click', handler);
      });
      const handleSelect = () => select(modelSelect.value);
      modelSelect?.addEventListener('change', handleSelect);
      select(section.dataset.selectedModel || 'L1', false);
      cleanups.set(section, () => { animation?.cancel(); handlers.forEach((remove) => remove()); modelSelect?.removeEventListener('change', handleSelect); cleanups.delete(section); });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector?.('[data-l-series-comparison]');
    if (section) cleanups.get(section)?.();
  });
})();
